import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TicketHolderForm } from '@products/models/holder.model';
import { environment } from '@src/environments/environment';
import { HelperService } from '@store/helpers/helper.service';

@Injectable({
  providedIn: 'root'
})
export class HolderService {
  private readonly http = inject(HttpClient);
  private readonly helperService = inject(HelperService);

  getTariffHolderQuestionnaire$(eventId: number, ticketPersonIds: number[]) {
    let params: HttpParams = new HttpParams();

    params = params.append('sr', this.helperService.isSelfRegistration());
    ticketPersonIds.forEach((ticketPersonId) => (params = params.append('ticketPersonIds', `${ticketPersonId}`)));

    return this.http.get(`${environment.protocol}${environment.webApiUrl}/event/${eventId}/visitor-questionnaire`, {
      params
    });
  }

  getTicketByHolder(hash: string) {
    return this.http.get(`${environment.protocol}${environment.webApiUrl}/person/ticket-by-holder/${hash}`);
  }

  postTicketHolderForm(data: TicketHolderForm) {
    return this.http.post(
      `${environment.protocol}${environment.webApiUrl}/person/visitors-form${
        this.helperService.isSelfRegistration() ? '?sr=true' : ''
      }`,
      data
    );
  }

  downloadTicket(hash: string) {
    return this.http.get(`${environment.protocol}${environment.webApiUrl}/person/download-ticket/${hash}`, {
      responseType: 'blob'
    });
  }

  downloadMobileTicket(hash: string) {
    return this.http.get(`${environment.protocol}${environment.webApiUrl}/person/download-mobile-ticket/${hash}`, {
      responseType: 'blob'
    });
  }

  downloadPassBook(hash: string) {
    return this.http.get(`${environment.protocol}${environment.webApiUrl}/person/download-passbook/${hash}`, {
      responseType: 'blob'
    });
  }
}
